document.addEventListener("DOMContentLoaded", function () {

  const wishlistKey = "ctu_wishlist";
  let wishlist = JSON.parse(localStorage.getItem(wishlistKey)) || [];

  function saveWishlist() {
    localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
  }

  function toggleWishlist(product) {
    const exists = wishlist.find(item => item.id == product.id);

    if (exists) {
      wishlist = wishlist.filter(item => item.id != product.id);
      return false; // removed
    } else {
      wishlist.push(product);
      return true; // added
    }
  }

  // Update Hearts on Load
  document.querySelectorAll(".ctu-wishlist-btn").forEach(btn => {
    const productId = btn.dataset.productId;
    const icon = btn.querySelector(".ctu-wishlist-icon");

    if (wishlist.find(item => item.id == productId)) {
      icon.classList.add("active-heart");
    }
  });

  // Click Events
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".ctu-wishlist-btn")) return;

    const btn = e.target.closest(".ctu-wishlist-btn");
    const icon = btn.querySelector(".ctu-wishlist-icon");

    const product = {
      id: btn.dataset.productId,
      handle: btn.dataset.productHandle,
      title: btn.dataset.productTitle,
      image: btn.dataset.productImage
    };

    const added = toggleWishlist(product);
    saveWishlist();

    if (added) {
      icon.classList.add("active-heart");
    } else {
      icon.classList.remove("active-heart");
    }
  });
});
